import { render, staticRenderFns } from "./UpgradeModal2.vue?vue&type=template&id=234fb233"
import script from "./UpgradeModal2.vue?vue&type=script&lang=js"
export * from "./UpgradeModal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports